// eslint-disable-next-line import/no-duplicates
import Swiper from 'swiper';
// eslint-disable-next-line import/no-duplicates
import SwiperCore, { Thumbs } from 'swiper/core';
import PerfectScrollbar from 'perfect-scrollbar';

SwiperCore.use([Thumbs]);

const psInstances = [];

const createSlider = ($sliderThumb, $sliderMain) => {
  const galleryThumbs = new Swiper($sliderThumb, {
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  const galleryMain = new Swiper($sliderMain, {
    navigation: {
      nextEl: '.js-event-speaker-slider-button-next',
      prevEl: '.js-event-speaker-slider-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  galleryMain.on('slideChange', () => {
    psInstances.forEach((ps) => ps.update());
  });
}

export default function initSpeakersSlider() {
  const $container = document.querySelector('.cp-speakers-slider');

  if (!$container) {
    return;
  }

  const psArray = $container.querySelectorAll('.js-container-description');
  [...psArray].forEach((el) => {
    psInstances.push(new PerfectScrollbar(el, {
      wheelPropagation: true,
    }));
  })

  const $sliderMain = $container.querySelector('.js-main-speakers-slider');
  const $sliderThumb = $container.querySelector('.js-thumbs-speakers-slider');

  createSlider($sliderThumb, $sliderMain)
}
